// Vendor Libs
import React from 'react';
import {useSelector} from 'react-redux';

// Dish Tech React
import {useRouter} from '@dishtech-react/hooks';
import {AuthLoading, Unauthorized} from '@dishtech-react/core';

// Contexts
import {BrowserRouter, Route} from 'react-router-dom';
import {RouteContext} from '../../../contexts/route-context';

import Whitelist from '../../Whitelist.tsx';
import logo from '../../../assets/dish_logo_red.svg';

const whitelistRoute = (
  <BrowserRouter>
    <Route component={Whitelist} path="/" />
    <Route component={Whitelist} path="Whitelist/*" />
  </BrowserRouter>
);

const Main = () => {
  const authorized = useSelector(({auth: {user: {isAuthorized} = {}} = {}}) => isAuthorized);
  const isCredentialExpired = useSelector(
    ({auth: {user: {credentialsNonExpired} = {}} = {}}) => !credentialsNonExpired
  );

  return (
    <div className="main">
      <RouteContext.Provider value={useRouter()}>
        {isCredentialExpired ? (
          <AuthLoading img={logo} />
        ) : authorized !== false ? (
          <div className="main--content">{whitelistRoute}</div>
        ) : (
          <Unauthorized />
        )}
      </RouteContext.Provider>
    </div>
  );
};

export default Main;
